export const setScrfToken = (token: string): void => {
  localStorage.setItem("csrf_token", token);
};

export const getScrfToken = (): string | null => {
  return typeof localStorage === "object" ? localStorage.getItem("csrf_token") : null;
};

export const removeScrfToken = (): void => {
  if (getScrfToken() != null) localStorage.removeItem("csrf_token");
};
